import React, { useRef } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Copy } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";

interface ShareDialogProps {
  title: string;
  url: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const ShareDialog = ({ title, url, open, onOpenChange }: ShareDialogProps) => {
  const { toast } = useToast();
  const inputRef = useRef<HTMLInputElement>(null);
  const shareUrl = `${window.location.origin}/player/${btoa(encodeURIComponent(url))}`;

  const handleCopy = () => {
    if (inputRef.current) {
      inputRef.current.select();
      document.execCommand("copy");
      toast({
        title: "Link copied",
        description: "Share link copied to clipboard",
      });
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Share Episode</DialogTitle>
          <DialogDescription>
            Copy the link below to share this episode with others
          </DialogDescription>
        </DialogHeader>
        <div className="flex gap-2">
          <Input
            ref={inputRef}
            value={shareUrl}
            readOnly
            className="flex-1"
            onClick={(e) => (e.target as HTMLInputElement).select()}
          />
          <Button onClick={handleCopy} className="flex-shrink-0">
            <Copy className="h-4 w-4 mr-2" />
            Copy
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ShareDialog;
